
export default {
    appName:"R:EmoTalkie",
}

